import React, { useRef, useState } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showFormattedDate } from "../../../../Utils";
import { Button } from "../../../../shared/Button/Button";
import { updateTimeTracking } from "../../../../Actions/BusinessInsights/businessInsightActions";
import { uiNotification } from "../../../../services/UINotificationService";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import styles from "./ClockData.module.scss";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";
import { useCurrentUserQuery } from "../../../../api/queries/useUserQuery";
import { DATE_FORMAT_MAP, TIME_FORMAT_MAP } from "./TrackedAs.utils";

const ClockInData = ({ detail, updateTimeTracking, userPrivileges }) => {
  const [editClockIn, setEditClockIn] = useState({});
  const { tCommon } = useAppTranslation.Common();
  const [selectedDate, setSelectedDate] = useState(detail.clock_in);
  const [isLoading, setIsLoading] = useState(false);

  const { data: user } = useCurrentUserQuery();

  const datePickerContainer = useRef(null);

  const editClockInAvailable =
    moment(new Date()).diff(moment(detail.clock_in), "days") <= 14 &&
    userPrivileges.indexOf("edit-time-card") > -1;

  const clockInMinDate = new Date(
    new Date().setFullYear(
      moment().add(-14, "day").year(),
      moment().add(-14, "day").month(),
      moment().add(-14, "day").date(),
    ),
  );
  const clockInMaxDate = new Date(
    new Date().setFullYear(
      moment(detail.clock_out).year(),
      moment(detail.clock_out).month(),
      moment(detail.clock_out).date(),
    ),
  );

  const clockInMaxTime = moment(selectedDate).isSame(
    moment(detail.clock_out),
    "days",
  )
    ? new Date(
        new Date().setHours(
          moment(detail.clock_out).hours(),
          moment(detail.clock_out).minutes() - 1,
          0,
          0,
        ),
      )
    : new Date(new Date().setHours(23, 59, 0, 0));

  const handleEditClockIn = (date) => {
    const languageData = JSON.parse(localStorage.getItem("languageData"));
    const newDate = moment(date).format("YYYY-MM-DD HH:mm:ss");
    setIsLoading(true);

    updateTimeTracking(detail.id, {
      clock_in: newDate,
      clock_out: detail.clock_out,
    })
      .then((res) => {
        uiNotification.success(
          languageData.global[res.message] || "Edited Successfully",
        );
        setEditClockIn({});
      })
      .catch((res) => {
        uiNotification.error(
          languageData.global[res.message] ||
            tCommon(`apiError.${res.message}`, "Unable To Edit"),
        );
      })
      .finally(() => setIsLoading(false));
  };

  return editClockIn.id === detail.id ? (
    <>
      <div ref={datePickerContainer}>
        <DatePicker
          selected={new Date(moment(selectedDate).format())}
          onChange={(date) => setSelectedDate(date)}
          showTimeSelect
          timeIntervals={1}
          timeFormat={TIME_FORMAT_MAP[user.timeFormat]}
          dateFormat={
            DATE_FORMAT_MAP[user.dateFormat] +
            " " +
            TIME_FORMAT_MAP[user.timeFormat]
          }
          minDate={clockInMinDate}
          maxDate={clockInMaxDate}
          minTime={new Date(new Date().setHours(0, 0, 0, 0))}
          maxTime={clockInMaxTime}
          className="time-edit-datepicker"
          open
          calendarContainer={({ className, children }) => (
            <div className={styles.calendarContainer}>
              <div className={className}>{children}</div>
              <div className={styles.calendarButtons}>
                <Button
                  size="tiny"
                  onClick={() => setEditClockIn({})}
                  isDisabled={isLoading}
                >
                  Cancel
                </Button>
                <Button
                  size="tiny"
                  onClick={() => handleEditClockIn(selectedDate)}
                  leftAdornment={
                    isLoading ? (
                      <CircularProgress size="small" color="white" />
                    ) : null
                  }
                  isDisabled={isLoading}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
        />
      </div>
    </>
  ) : (
    <div className="flex items-center gap-8">
      {showFormattedDate(detail.clock_in, true, "", "YYYY-MM-DD HH:mm:ss")}
      {editClockInAvailable && (
        <Button
          size="tiny"
          variant="text"
          onClick={() => {
            setEditClockIn(detail);
          }}
        >
          <i className="fa fa-pencil-alt"></i>
        </Button>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateTimeTracking: updateTimeTracking,
    },
    dispatch,
  );
};

export default connect(null, mapDispatchToProps)(ClockInData);
